import * as React from 'react';
import { ActorApiDateDisplay } from '../../../../../../../../../../../../../../../../../../../../../../actor/components/display/date';
import { useSanityLatestNewsPublishDateById } from '../../../../../../../../../../../../../../../../../../../../../../sanity';

export const LatestNewsPublishDateContent = (props: {
  id: string,
}) => {
  const {
    id,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useSanityLatestNewsPublishDateById(id);
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format="dd/MM/yyyy"
      formatMq={false}
    />
  );
};
